import { faCircleInfo, faRectangleList } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { makeStyles } from "@material-ui/core/styles";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DifferencesModal from "./DifferencesModal";
import {
  Accordion,
  AccordionSummary,
  Alert,
  Box,
  Button,
  Card,
  Paper,
  Table,
  TableCell,
  TableHead, TableBody,
  TableContainer,
  TableRow,
  FormControl,
  FormControlLabel,
  Modal,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import AccordionDetails from "@mui/material/AccordionDetails";
import Checkbox from "@mui/material/Checkbox";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { Icon } from "@progress/kendo-react-common";
import HistoryColumns from "./HistoryColumns";
import axios from "axios";
import { useFormik } from "formik";
import moment from "moment";
import { useAuth } from "oidc-react";
import dayjs from "dayjs";
import React, { Fragment, useCallback, useEffect, useMemo, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { CardBody, Col, Container, Row } from "reactstrap";
import * as Yup from "yup";
import { companyArray, getUserRole, isOlderThen, ShowError, ShowSucess } from "../../_helper/helper";
import { ConcatenedColumns, loadingPanel } from "../../CommonComponents/CommonFunction";
import ActiveHealthAndDeductionPlan from "./Components/ActiveHealthAndDeductionPlan";

import ConfirmationModel from "./Components/ConfirmationModel";
import DependentSelection from "./Components/DependentSelection";
import DocumentViewer from "./Components/DocumentView";
import { currentProcessStatus, getAuditTrail } from "../../CommonFunction/ProcessStatus";
import StepperComponent from "../../CommonComponents/Stepper/StepperComponent";
import { advanceSearch } from "../../_helper/services/advanceSearchv2";
import ErrorBoundary from "../../ErrorBoundry";
import ApprovalModal from "../../CommonComponents/ApprovalModal/ApprovalModal";
import StatusCard from "../../CommonComponents/StatusCard/StatusCard";
import HistoryDataTable from "../../CommonComponents/AuditLog/HistoryDataTable";
import { Btn } from "../../AbstractElements";
// import HistoryDataTable from "../../CommonComponents/HistoryDataTable";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    ".&.MuiExpansionPanelSummary-content": {
      padding: 0,
    },
    ".css-sh22l5-MuiButtonBase-root-MuiAccordionSummary-root.Mui-expanded": {
      minHeight: "32px",
    },
    "& .MuiPaper-root": {
      background: "none",
      display: "block",
    },
    margin: "0 !important",
    borderTopWidth: 1,
    borderTopColor: "#ccc",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "70%",
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    fontWeight: "bold",
  },
}));

const HealthOpenEnrollmentMain = () => {
  const classes = useStyles();
  const { id: employeeId } = useParams()
  // const { state } =  useLocation()
  // const {Health_CurrentProcessid : healthCurrentProcessid} = state
  const initialDependent = {
    lastName: "",
    firstName: "",
    relation: "",
    ssn: "",
    gender: "",
    dob: "",
    mailingAddress: "",
    email: "",
    middleName: "",
  };
  const location = useLocation();
  const columns = location.state;
  const [dependentInformation, setDependentInformation] = useState([]);
  const [dependentforApproval, setDependentforApproval] = useState([])
  const [deletedDependent, setdeletedDependent] = useState([]);
  const [isDocumentViewer, setIsDocumentViewer] = useState(false);
  const [auditTrailData, setAuditTrailData] = useState([])
  const [isConfirmationModel, setIsConfirmationModel] = useState(false);
  const [ConfirmationData, setConfirmationData] = useState({});
  const [historyData, setHistoryData] = useState([]);
  const [isHistoryModalOpen, setIsHistoryModalOpen] = useState(false);
  const [differenceData, setDifferenceData] = useState([]);
  const [openDiffModal, setOpenDiffModal] = useState(false);
  const [sortData, setSortData] = useState([
    { field: "changeDateTime", dir: "desc" },
  ]);
  const [expanded, setExpanded] = React.useState({
    empDetail: true,
    healthandDeduction: true,
    dependent: true,
  });
  const [approvalHandleModal, setApprovalHandleModal] = useState(false)
  const [selectedOption, setSelectedOption] = useState('');
  const [remarks, setRemarks] = useState('');
  const [errorsApproval, setErrorsApproval] = useState({ option: false, remarks: false });
  const [sortedColumns, setSortedColumns] = useState([]);

  useEffect(() => {
    ConcatenedColumns(columns, HistoryColumns, setSortedColumns, userData);
  }, [columns, sortData]);
  const handleChangeExpanded = (panel) => (event, isExpanded) => {
    setExpanded((prevState) => ({
      ...prevState,
      [panel]: isExpanded,
    }));
  };
  const { userData } = useAuth();


  const [show, setShow] = useState(false);
  const [loding, setLoading] = useState(false);
  const [defaultOpen, setDefaultOpen] = useState(true);
  const [selfData, setSelfData] = useState({});
  const [processStatus, setProcessStatus] = useState([])


  const [schema, setPerformanceSchema] = useState({
    employee_no: Yup.string().required("Employee No. is required"),
    DOB: Yup.string().required("DOB is required"),
    last_name: Yup.string().required("Last Name is required"),
    ssn: Yup.string()
      .required("SSN is required")
      .test(
        "len",
        "Must be exactly 4 characters",
        (val) => val && val.toString().length === 4
      ),
  });

  const initialItem = {
    employee_no: "",
    DOB: "",
    last_name: "",
    ssn: "",
    role: '',
    HealthVendor: "",
    healthPlan: "",
    UID: "",
    Employeetype: "",
    healthDeductionClass: "",
    subscriberId: "",
    id: "",
    amount: "",
    email: "",
    mailingAddress: "",
    oldHelthPlan: "",
    oldHelthVendor: "",
    healthCurrentProcessid: "",
    healthHrcontrol: ""
  };


  useEffect(() => {
    if (employeeId) {

      setLoading(true)
      getBenefitsData(employeeId)
      // searchEmployeeAPI(userData?.profile?.DOB, userData?.profile?.SSN, userData?.profile?.LastName, userData?.profile?.EmployeeID)
      // setValues({
      //   ...values,
      //   DOB: userData?.profile?.DOB,
      //   employee_no: userData?.profile?.EmployeeID,
      //   last_name: userData?.profile?.LastName,
      //   ssn: userData?.profile?.SSN,
      // })
    }
  }, [employeeId])

  const getProcessStatus = async () => {
    const response = await currentProcessStatus(132)
    setProcessStatus(response)
    console.log(response, 'currentProcessStatus')
  }

  const handleSortChange = (sort) => {
    setSortData(sort);
  };

  useEffect(() => {
    getProcessStatus()
  }, [])

  const handleUpdatePlan = () => {
    if (values?.UID && values?.healthPlan && values?.HealthVendor) {
      setLoading(true);
      const payload = {
        uid: values?.UID,
        healthVendor: values?.HealthVendor,
        healthPlan: values?.healthPlan,
        healthDeductionClass: values?.healthDeductionClass,
      };
      axios
        .put(
          `${process.env.REACT_APP_API_DOTNET_URL}/BenefitsMASTER/update`,
          [{ ...payload }],
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem(
                "jwt_access_token"
              )}`,
            },
          }
        )
        .then((response) => {
          setLoading(false);
          ShowSucess("Successfully Updated.");
        })
        .catch((error) => {
          setLoading(false);
          ShowError("Internal Server Error !");
        });
    } else {
      ShowError("Please select any health plan");
    }
  };

  const OpenHistoryComponent = () => {
    // This function will now ONLY start the data fetch process.
    if (values.UID) {
      getData(values);
    }
  };

  const onSubmit = (e) => {
    // API Calling
    setLoading(true);
    // searchEmployeeAPI(values?.DOB, values?.ssn, values?.last_name, values?.employee_no);
    getBenefitsData(employeeId);
  };

  const getNextObjectAndCurrentSeqById = (data, currentId) => {
    const currentIndex = data.findIndex(item => item.ID === currentId);
    if (currentIndex !== -1) {
      const currentSeq = data[currentIndex].Seq;
      const nextObject = currentIndex < data.length - 1 ? data[currentIndex + 1] : null;
      return {
        currentSeq: currentSeq,
        nextObject: nextObject
      };
    }
    return null;
  }

  const handleDependentUpdate = async (newDependentInfo) => {
    if (newDependentInfo && Object.keys(newDependentInfo).length) {
      dependentInformation.push(newDependentInfo)
    }
    if (
      dependentInformation.some(
        (i) =>
          !i.firstName ||
          !i.lastName ||
          !i.middleName ||
          (!i["role"]?.includes('Coverage') && i.HealthSubscriberID && !i.relation) ||
          !i.gender ||
          (i?.relation === 'Child' && isOlderThen(i.dob))
        // ||
        // !i.dob
      )
    ) {
      ShowError("Please Check Dependent Information");
      return false;
    }
    setLoading(true);
    let currnetClassValue = ""
    if (values?.healthPlan && values?.HealthVendor) {
      currnetClassValue = await setClassValues(dependentInformation)
    }

    axios
      .post(
        `${process.env.REACT_APP_API_DOTNET_URL}/BenefitsMASTER/CreateOrUpdateDeteteBenefits`,
        {
          createnupdate: [
            ...dependentInformation?.map((i) => {
              i?.uid && delete i.ssn
              return {
                ...i, dependentFor: "Health", healthDeductionClass: i.HealthSubscriberID ? currnetClassValue : "",
                healthSubscriberID: values?.healthPlan && values?.HealthVendor ? i.HealthSubscriberID : "",
                employeeId: !i?.uuid ? ' ' : i.employeeId,
                benefitId: !i?.uuid ? " " : i.employeeId,
                healthType: i.relation,
                "healthCurrentProcessid": processStatus?.[1]?.ID,
                // "lifeCurrentProcessid": 0,
                // "dentalCurrentProcessid": 0,
                "hrControlTypes": ["Health"],
                healthHrcontrol: i.HealthSubscriberID ? selfData?.Health_Hrcontrol : ""
              }
            }),
            ...[
              {
                uid: values?.UID,
                healthVendor: values?.HealthVendor,
                healthPlan: values?.healthPlan,
                healthDeductionClass: currnetClassValue,
                subscriberId: values?.subscriberId,
                id: values?.id,
                dependentFor: "Health",
                approvedBy: userData?.profile?.EmployeeID,
                ...(!values?.healthPlan && !values?.HealthVendor && { healthSubscriberID: "" }),
                "hrControlTypes": ["Health"],
                "healthCurrentProcessid": values?.healthCurrentProcessid,
                healthHrcontrol: selfData?.Health_Hrcontrol
              },
            ],
          ],
          deletedList: deletedDependent,
          transactionStatus: "Update",
          currentProcessid: values?.healthCurrentProcessid || '0',
          hrControl: selfData?.Health_Hrcontrol,
          remark: "",
          type: "",
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("jwt_access_token")}`,
          },
        }
      )
      .then(async (response) => {
        await getBenefitsData(values?.employee_no);
        fetchAuditTrail()
        ShowSucess("Successfully!");
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const handleDependentDelete = (uid) => {
    setdeletedDependent([...deletedDependent, uid]);
  };

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
    validateForm,
    setValues,
  } = useFormik({
    initialValues: initialItem,
    validationSchema: Yup.object().shape(schema),
    onSubmit,
  });


  const getData = (values) => {
    setLoading(true);
    const payload = {
      tableName: "vw_auditBenefits_MASTER",
      // tableName: "Benefits_Death_Intake",
      SearchParams: "",
      columns: "*",
      pageNumber: 1,
      pageSize: 10000000,
      orderBy: "ID DESC",
      sortBy: "",
      orderByMultiple: "",
      limit: 10000000000,
      sortData: "",
      additionalWhere: `uid = '${values?.UID}'`,
    };
    axios
      .post(`${process.env.REACT_APP_API_DOTNET_URL}/BenefitAdvanceSearch/Benefits-global`, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("jwt_access_token")}`,
          Role: getUserRole(userData),
        },
      })
      .then((response) => {
        setHistoryData(response?.data?.results);
        setIsHistoryModalOpen(true);
        setLoading(false);
        console.log(response, 'intackdata')
      })
      .catch((error) => {
        setLoading(false);
      });
  }


  const renderGroupCheckbox = (
    size = "large",
    stateName,
    value,
    other = null
  ) => {
    let defaultChk = (
      <Checkbox
        size={size}
        checked={values[stateName] == value}
        onChange={(e) => {
          setFieldValue(stateName, value);
        }}
      />
    );
    if (other && other.matchkey && other.matchkey1) {
      defaultChk = (
        <Checkbox
          size={size}
          checked={
            values[stateName] == value &&
            values[other.matchkey] == other.matchvalue &&
            values[other.matchkey1] == other.matchvalue1
          }
          // disabled={
          //   !dependentInformation.some((item) =>
          //     ["Spouse", "Domesticpartner", "Child"].includes(item.relation)
          //   )
          // }
          disabled={other?.disabled ? other?.disabled : false}
          onChange={(e) => {
            if (
              stateName == "healthDeductionClass" &&
              other?.changeTarget1 &&
              other?.changeTarget1 == "HealthVendor" &&
              other?.changeTarget2 == "healthPlan"
            ) {
              setFieldValue(other?.changeTarget1, other?.changeTargetValue1);
              setFieldValue(other?.changeTarget2, other?.changeTargetValue2);
              // setFieldValue("amount", other?.amount);
            }
            // if (stateName == 'healthPlan' && other?.changeTarget1 && other?.changeTarget1=='HealthVendor' && other?.changeTarget2=='healthPlan') {
            //   setFieldValue(other?.changeTarget1, other?.changeTargetValue1)
            //   setFieldValue(other?.changeTarget2, other?.changeTargetValue2)
            //   setFieldValue('HSAANDPPO',values.HSAANDPPO)
            // }

            setFieldValue(stateName, value);
          }}
        />
      );
    } else if (other && other.matchkey) {
      defaultChk = (
        <Checkbox
          size={size}
          checked={
            values[stateName] == value &&
            values[other.matchkey] == other.matchvalue
          }
          disabled={other?.disabled ? other?.disabled : false}
          onChange={(e) => {
            if (
              stateName == "healthDeductionClass" &&
              other?.changeTarget1 &&
              other?.changeTarget1 == "HealthVendor" &&
              other?.changeTarget2 == "healthPlan"
            ) {
              setFieldValue(other?.changeTarget1, other?.changeTargetValue1);
              setFieldValue(other?.changeTarget2, other?.changeTargetValue2);
            }
            if (stateName == "healthPlan" && other.matchkey) {
              if (e.target.checked) {
                setFieldValue(
                  "healthDeductionClass",
                  values.healthDeductionClass
                );
                setFieldValue(other?.matchkey, other?.matchvalue)
              } else {
                if (values?.oldHelthPlan && values?.oldHelthVendor) {
                  setIsConfirmationModel(true)
                } else {
                  handleUnClick()
                }


                // setFieldValue(
                //   "healthDeductionClass",
                //   ""
                // );
                // setFieldValue(other?.matchkey, "")
              }
            }
            if (e.target.checked) {
              setFieldValue(stateName, value);
            }
            // else {
            //   setFieldValue(stateName, "");
            // }
          }}
        />
      );
    } else {
      defaultChk = (
        <Checkbox
          size={size}
          checked={values[stateName] == value}
          onChange={(e) => {
            setFieldValue(stateName, value);
          }}
        />
      );
    }


    return defaultChk;
  };

  function renderTextInput(stateName, label, others = {}) {
    let other = {
      disabled: false,
      maxLength: "",
      multiline: false,
      required: false,
      shrink: true,
      ...others,
    };
    let { disabled, maxLength, multiline, required, shrink } = other;
    return (
      <TextField
        fullWidth
        size="small"
        inputProps={{
          style: {
            fontSize: "14px",
            paddingTop: "12px",
            width: "100%",
          },
          readOnly: disabled,
        }}
        margin="dense"
        variant="outlined"
        label={label}
        name={stateName}
        id={stateName}
        multiline={multiline}
        rows={multiline ? 3 : 1}
        value={values[stateName]}
        InputLabelProps={{ shrink: shrink ? shrink : false }}
        shrink={shrink ? shrink : false}
        onChange={(e) => {
          if (!disabled) {
            setShow(false);
            handleChange(e);
          }
        }}
        onBlur={handleBlur}
        error={!disabled && touched[stateName] && errors[stateName]}
        helperText={
          !required && !disabled && touched[stateName] && errors[stateName]
        }
        disabled={disabled}
        required={required}
      />
    );
  }

  function renderDateInput(
    stateName,
    label,
    disabled = false,
    minDate = null
    // maxDate
  ) {
    return (
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DesktopDatePicker
          inputVariant={"outlined"}
          margin="dense"
          format="MM/dd/yyyy"
          label={label}
          minDate={minDate}
          // maxDate={maxDate}
          value={values[stateName]}
          KeyboardButtonProps={{ "aria-label": label }}
          disabled={disabled}
          onChange={(value) => {
            const formatDate = value?.$d;
            const date = formatDate
              ? moment(formatDate).format("YYYY-MM-DD hh:mm:ss")
              : null;
            setShow(false);
            setFieldValue(stateName, date);
          }}
          onBlur={handleBlur}
          renderInput={(params) => (
            <TextField
              fullWidth
              margin="dense"
              size="small"
              InputLabelProps={{ shrink: true }}
              {...params}
              error={!disabled && errors[stateName]}
              helperText={!disabled && errors[stateName]}
            />
          )}
        />
      </LocalizationProvider>
    );
  }


  function renderDropDown(stateName, label, value, disabled) {
    return (
      <div>
        <TextField
          margin="dense"
          className="flex w-full  mt-2"
          variant="outlined"
          select
          SelectProps={{ native: true }}
          style={{ width: "100%" }}
          size="small"
          disabled={disabled}
          inputProps={{
            style: {
              fontSize: "14px",
              color: "black",
              paddingTop: "12px",
            },
          }}
          label={label}
          name={stateName}
          InputLabelProps={{ shrink: true }}
          onChange={(e) => {
            handleChange(e);
          }}
          error={!disabled && errors[stateName]}
          helperText={!disabled && errors[stateName]}
          value={values[stateName]}
        >
          {/* <option value={""} disabled> */}
          {/* value={values[stateName]}> */}
          <option value={""} disabled>
            Select {label}
          </option>

          {value.length &&
            value.map((option) => (
              <option key={option.value} value={option.value}>
                {option.name}
              </option>
            ))}
        </TextField>
      </div>
    );
  }

  const renderCheckbox = (size = "large", stateName, value) => {
    return (
      <Checkbox
        size={size}
        checked={values[stateName] == value}
        onChange={(e) => {
          setFieldValue(stateName, value);
        }}
      />
    );
  };

  const setAmount = (currentClass) => {
    let getAmount = companyArray
      .find((item) => item.vendor_name == values?.HealthVendor)
      ?.vendor_items.find((item) => item.vendor_code == values?.healthPlan)
      ?.classInfo.find(
        (ite) => ite.value == currentClass
      )?.amount;
    setFieldValue("amount", getAmount);
  }

  const setClassValues = async (dependentArray1) => {

    let dependentArray = dependentArray1?.filter((i) => {
      return !!!i.role?.includes("Coverage") && !!i.HealthSubscriberID
    })

    const uniqueValues = [
      ...new Set(dependentArray.map((obj) => obj.relation)),
    ];


    if (uniqueValues.every((i) => i == "")) {
      if (values?.healthDeductionClass != "I") {
        setAmount("I")
        ShowSucess(`Class changed ${values?.healthDeductionClass} to I `);
        setFieldValue("healthDeductionClass", "I");
      }
      return "I";
    }
    if (
      uniqueValues.length == 1
        ? uniqueValues.every((i) => ["Spouse", "Domesticpartner"].includes(i))
        : uniqueValues.every(
          (i) => ["Spouse", "Domesticpartner"].includes(i) || i == ""
        )
    ) {
      if (values?.healthDeductionClass != "II") {
        setAmount("II")
        ShowSucess(`Class changed ${values?.healthDeductionClass} to II `);
        setFieldValue("healthDeductionClass", "II");
      }
      return "II";
    }
    if (
      uniqueValues.length == 1
        ? uniqueValues.every((i) => ["Child"].includes(i))
        : uniqueValues.every((i) => i == "Child" || i == "")
    ) {
      if (values?.healthDeductionClass != "III") {
        setAmount("III")
        ShowSucess(`Class changed ${values?.healthDeductionClass} to III`);
        setFieldValue("healthDeductionClass", "III");
      }
      return "III";
    }
    if (
      uniqueValues.length == 1
        ? uniqueValues.some((i) => ["Spouse", "Domesticpartner"].includes(i)) &&
        uniqueValues.some((i) => ["Child"].includes(i))
        : uniqueValues.some(
          (i) => ["Spouse", "Domesticpartner"].includes(i) || i == ""
        ) && uniqueValues.some((i) => ["Child"].includes(i))
    ) {
      if (values?.healthDeductionClass != "IV") {
        setAmount("IV")
        ShowSucess(`Class changed ${values?.healthDeductionClass} to IV `);
        setFieldValue("healthDeductionClass", "IV");
      }
      return "IV";
    }
  };



  const getDateDifference = () => {

    const currentYear = moment().year();
    const defaultDate = moment(`09-30`, 'MM-DD').year(currentYear);
    const currentDate = moment().year(currentYear);

    // Adjust the year for selectedDate if it is before constDate
    if (defaultDate.isBefore(currentDate)) {
      defaultDate.add(1, 'year');
    }

    // Calculate the difference in days
    const diffDays = defaultDate.diff(currentDate, 'days');

    return { diffDays, defaultDate, currentDate };
  }

  console.log(dependentforApproval, 'dependentforApproval1221')
  const getBenefitsData = async () => {
    const newBaseURL = process.env.REACT_APP_API_DOTNET_URL;
    const payload = {
      tableName: "sp_BenefitsDependent_v2",
      SearchParams: `[{"columnName":"EmpId","operator":"=","value":'${employeeId}',"dataType":"VARCHAR"}]`,
      columns: "*",
      pageNumber: 1,
      pageSize: 10000000,
      orderBy: "",
      sortBy: "Role desc",
      orderByMultiple: "",
      limit: 10000000000,
      sortData: "",
      additionalWhere: "",
    };
    axios
      .post(`${newBaseURL}/BenefitAdvanceSearch/Benefits-global`, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("jwt_access_token")}`,
          Role: getUserRole(userData),
        },
      })
      .then((response) => {
        let finalData = response?.data?.results;
        let resData = finalData.find((i) => i.Dependants == 'Self')
        finalData = finalData?.map((i) => {
          return {
            ...i,
            firstName: i.FirstName,
            middleName: i.MiddleName,
            lastName: i.LastName,
            role: i.Role,
            relation: i.Relation,
            gender: i.Gender,
            dob: i.DOB,
            mailingAddress: i.MailingAddress,
            email: i.Email,
            healthDeductionClass: i.HealthDeductionClass,
            healthHrcontrol: i?.Health_Hrcontrol ?? "",
          }
        })
        setSelfData(resData)
        console.log(resData, 'resData')
        let searchData = {
          UID: resData?.UID,
          // id: resData?.UID,
          employee_no: resData?.EmployeeID,
          subscriberId: resData?.SubscriberID,
          Employeetype: resData?.EmployeeType,
          HealthVendor: resData?.HealthVendor,
          healthPlan: resData?.HealthPlan,
          healthDeductionClass: resData?.HealthDeductionClass,
          email: resData?.Email,
          lastName: resData?.LastName,
          mailingAddress: resData?.MailingAddress,
          oldHelthPlan: resData?.HealthPlan,
          oldHelthVendor: resData?.HealthVendor, //
          healthCurrentProcessid: resData?.Health_CurrentProcessid,
          healthHrcontrol: resData?.Health_Hrcontrol ?? "",
        };
        setValues((state) => { return { ...state, ...searchData } });

        setDependentInformation(
          finalData.length > 1
            ? finalData.filter((i) => i.Dependants == "Health Dependants")?.length ? finalData.filter((i) => i.Dependants == "Health Dependants") : [] : []
        );
        setDependentforApproval(
          finalData.length > 1
            ? finalData.filter((i) => i.Dependants == "Health Dependants")?.length ? finalData.filter((i) => i.Dependants == "Health Dependants") : [] : []
        )
        // setDependentInformation(
        //   finalData.length > 1
        //     ? finalData.filter((i) => i.EmployeeID !== i.SubscriberID && i.Dependants == "Health Dependants")?.length ? finalData.filter((i) => i.EmployeeID !== i.SubscriberID && i.Dependants == "Health Dependants") : [
        //       {
        //         ...initialDependent,
        //         subscriberId: employeeId,
        //         email: values?.email,
        //         mailingAddress: values?.mailingAddress,
        //         lastName: values?.last_name,
        //       },
        //     ]
        //     : [
        //       {
        //         ...initialDependent,
        //         subscriberId: employeeId,
        //         email: values?.email,
        //         mailingAddress: values?.mailingAddress,
        //         lastName: values?.last_name,
        //       },
        //     ]
        // );
      })
      .catch((error) => {

      }).finally(() => {
        setLoading(false)
      })
  }

  const fetchAuditTrail = useCallback(async () => {
    if (!values?.healthHrcontrol) {
      return; // Return early if healthHrcontrol is not defined
    }

    try {
      const getAuditTrailData = await getAuditTrail(values.healthHrcontrol);
      console.log("MKS2", getAuditTrailData);
      if (getAuditTrailData != undefined) {
        setAuditTrailData(getAuditTrailData);
      }
    } catch (error) {
      console.error("Error fetching audit trail data:", error);
      // Optionally, you can handle the error state, e.g., set an error message state
    }
  }, [values?.healthHrcontrol]);

  useEffect(() => {
    fetchAuditTrail();
  }, [fetchAuditTrail]);


  const handleOpen = () => {
    setIsDocumentViewer(true);
  };

  const handleUnClick = () => {
    setValues({ ...values, healthPlan: "", HealthVendor: "", healthDeductionClass: "" })
  }

  const approvalHandler = useCallback(() => {
    setApprovalHandleModal(true)
  }, [])

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
    setErrorsApproval((prev) => ({ ...prev, option: false }));
  };

  const handleRemarksChange = (event) => {
    setRemarks(event.target.value);
    setErrorsApproval((prev) => ({ ...prev, remarks: false }));
  };

  const handleClose = () => {
    setApprovalHandleModal(false)
  }

  const handleApprovalSubmit = (approvalData) => {
    // "healthCurrentProcessid": processStatus?.[1]?.ID,
    //             // "lifeCurrentProcessid": 0,
    //             // "dentalCurrentProcessid": 0,
    //             "hrControlTypes": ["Health"],
    const { option, remarks } = approvalData
    let processId = processStatus?.[2]?.ID
    if (option == "Return") {
      processId = processStatus?.[0]?.ID
    }
    setLoading(true);
    axios
      .post(
        `${process.env.REACT_APP_API_DOTNET_URL}/BenefitsMASTER/CreateOrUpdateDeteteBenefits`,
        {
          createnupdate: [
            ...dependentforApproval?.map((i) => {
              i?.uid && delete i.ssn;
              return {
                ...i,
                dependentFor: "Health",
                healthDeductionClass: i.HealthDeductionClass,
                healthSubscriberID: i.HealthSubscriberID,
                employeeId: !i?.uuid ? " " : i.employeeId,
                benefitId: !i?.uuid ? " " : i.employeeId,
                healthType: i.relation,
                healthCurrentProcessid: processId,
                // "lifeCurrentProcessid": 0,
                // "dentalCurrentProcessid": 0,
                hrControlTypes: ["Health"],
                healthHrcontrol: i.HealthSubscriberID ? selfData?.Health_Hrcontrol : ""
              };
            }),
            ...[
              {
                uid: values?.UID,
                healthVendor: values?.HealthVendor,
                healthPlan: values?.healthPlan,
                healthDeductionClass: values?.healthDeductionClass,
                subscriberId: values?.subscriberId,
                id: values?.id,
                dependentFor: "Health",
                approvedBy: userData?.profile?.EmployeeID,
                ...(!values?.healthPlan &&
                  !values?.HealthVendor && { healthSubscriberID: "" }),
                hrControlTypes: ["Health"],
                healthCurrentProcessid: processId,
                healthHrcontrol: selfData?.Health_Hrcontrol

              },
            ],
          ],
          deletedList: [],
          transactionStatus: option,
          currentProcessid: processId,
          hrControl: selfData?.Health_Hrcontrol,
          remark: remarks,
          type: "",
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("jwt_access_token")}`,
          },
        }
      )
      .then(async (response) => {
        await getBenefitsData(values?.employee_no);
        getProcessStatus()
        fetchAuditTrail()
        ShowSucess("Successfully!");
        setLoading(false);
        handleClose();
      })
      .catch((error) => {
        setLoading(false);
      });

  };

  const actions = useMemo(() => {
    return [
      {
        title: "Show Details",
        action: (props) => {
          const findIndex =
            historyData &&
            historyData.findIndex((item) => {
              return item?.changeDateTime === props.dataItem.changeDateTime;
            });

          if (
            findIndex !== -1 &&
            findIndex + 1 < historyData.length
          ) {
            const filterData = [
              historyData[findIndex],
              historyData[findIndex + 1],
            ];

            setOpenDiffModal(true);
            setDifferenceData(filterData);
          }
        },
        icon: { iconName: "k-icon  k-i-eye" },
        className: "font-primary",
        style: { cursor: "pointer" },
      },
    ];
  });


  return (
    <Fragment>
      <ErrorBoundary>
        {isConfirmationModel &&
          <ConfirmationModel
            open={isConfirmationModel}
            setOpen={setIsConfirmationModel}
            // healthName={isDeSelectedHealth}
            handleSubmit={handleUnClick}
            modelTitle={"Are you sure to unsubscribe Health Insurance"}
          />
        }

        {isDocumentViewer && (
          <DocumentViewer
            open={isDocumentViewer}
            setOpen={setIsDocumentViewer}
            fullWidth
            fieldName={"healthSubscriberId"}
            controlName={"healthHrcontrol"}
            getBenefitsData={getBenefitsData}
            selfData={{
              lastName: selfData?.LastName,
              middleName: selfData?.FirstName,
              SubscriberID: selfData?.EmployeeID,
              hrControl: selfData?.Health_Hrcontrol,
            }}
            handleDependentUpdate={handleDependentUpdate}
            currentDependents={dependentInformation}
            planType="Health"
          />
        )}
        {loding && loadingPanel()}
        <Container fluid={true}>
          <Row className="bg-primary rounded m-0 p-0 py-3 mb-3 ">
            <Typography variant="h5">
              <Icon style={{ fontSize: "25px", margin: "10px" }} name="graph" />
              Change Status
            </Typography>
          </Row>
          {!loding &&
            (!values.healthPlan ? (
              <Alert severity="error" style={{ marginTop: "10px" }}>
                No Health Plan Is Selected
              </Alert>
            ) : null)}
          {/* {!show && !loding ? <Card style={{ marginTop: "10px" }}>
          <div style={{ padding: "40px", textAlign: 'center', fontSize: "26px" }}>
            <div style={{ textAlign: "center", marginBottom: "50px" }}>
              <SadImg></SadImg>
            </div>
            Employee details not found!
          </div>
        </Card> : null} */}
          {values?.Employeetype ? (
            <>
              <Card style={{ marginTop: "10px" }}>
                <Accordion
                  className={classes.root}
                  expanded={expanded.healthandDeduction}
                  onChange={handleChangeExpanded("healthandDeduction")}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2bh-content"
                    id="panel2bh-header"
                    className="sub-header w-100 p-1 bg-primary text-white"
                    style={{ width: "100%" }}
                  >
                    <FontAwesomeIcon
                      icon={faRectangleList}
                      className="sub-header"
                      style={{
                        // color: "#1569C7",
                        marginRight: "10px",
                        marginTop: "3px",
                      }}
                    />
                    <div
                      className="d-flex justify-content-between"
                      style={{ width: "100%" }}
                    >
                      <div style={{ fontSize: "0.9375rem", fontWeight: "bold" }}>
                        Health and Deduction Plan
                      </div>
                      <div style={{ marginRight: "20px" }}>
                        {/* <span style={{ fontSize: "1rem", fontWeight: "bold", margin: "0px 5px" }}> {getDateDifference()?.diffDays} Days</span>
                      Until Open Enrollment Ends on
                      <span style={{ fontSize: "1rem", fontWeight: "bold", margin: "0px 5px" }}> {moment(getDateDifference()?.defaultDate).format("MMM DD,YYYY")}</span> */}
                      </div>
                    </div>
                    {/* <Typography
                    className={classes.heading}
                    style={{ height: "auto" }}
                  >
                    Health and Deduction Plan
                  </Typography> */}
                  </AccordionSummary>
                  <AccordionDetails className="p-0 page-body-wrapper">
                    {values?.healthCurrentProcessid ? (
                      <div style={{ margin: "5px 0" }}>
                        <StepperComponent
                          currStep={values?.healthCurrentProcessid}
                          processStatus={processStatus}
                        />
                      </div>
                    ) : (
                      ""
                    )}
                    <StatusCard
                      auditTrail={auditTrailData}
                      processStatus={processStatus}
                    />
                    <ActiveHealthAndDeductionPlan
                      renderTextInput={renderTextInput}
                      renderCheckbox={renderCheckbox}
                      renderDropDown={renderDropDown}
                      renderDateInput={renderDateInput}
                      setValues={setValues}
                      values={values}
                      selfData={selfData}
                      handleUpdatePlan={handleUpdatePlan}
                      renderGroupCheckbox={renderGroupCheckbox}
                      isActiveUpdatePlan={
                        dependentInformation.length ? false : true
                      }
                      approvalHandler={approvalHandler}
                      currStep={values?.healthCurrentProcessid}
                      processStatus={processStatus}
                    />
                  </AccordionDetails>
                </Accordion>
              </Card>

              <Card style={{ marginTop: "10px" }}>
                <Accordion
                  className={classes.root}
                  expanded={expanded.dependent}
                  onChange={handleChangeExpanded("dependent")}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2bh-content"
                    id="panel2bh-header"
                    className="sub-header w-100 p-1 bg-primary text-white"
                    style={{ width: "100%" }}
                  >
                    <FontAwesomeIcon
                      icon={faRectangleList}
                      className="sub-header"
                      style={{
                        // color: "#1569C7",
                        marginRight: "10px",
                        marginTop: "3px",
                      }}
                    />
                    <Typography
                      className={classes.heading}
                      style={{ height: "auto" }}
                    >
                      Health Dependent Information
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails className="p-0 page-body-wrapper">
                    <DependentSelection
                      dependentInformation={dependentInformation}
                      setDependentInformation={setDependentInformation}
                      initialDependent={{
                        ...initialDependent,
                        subscriberId: values?.employee_no,
                        email: values?.email,
                        mailingAddress: values?.mailingAddress,
                        lastName: values?.last_name,
                      }}
                      handleDependentUpdate={handleDependentUpdate}
                      handleDependentDelete={handleDependentDelete}
                      setClassValues={setClassValues}
                      values={values?.healthDeductionClass}
                      allvalues={values}
                      handleOpen={handleOpen}
                      employeeId={employeeId}
                    />
                  </AccordionDetails>
                </Accordion>
              </Card>
            </>
          ) : null}

          {auditTrailData.length > 0 ? <Card className="p-3 my-3" elevation={1}>
            <CardBody>
              <Col xs={12} lg={4} md={4} sm={12} className="d-flex align-items-center justify-content-between w-100">
                <Typography variant="h6">
                  <FontAwesomeIcon
                    className="m-r-10 font-primary"
                    icon={faCircleInfo}
                    size="lg"
                  />
                  Audit Trail
                </Typography>
                <Btn
                  attrBtn={{
                    color: "primary",
                    onClick: () => {
                      OpenHistoryComponent();
                    },
                    style: {
                      marginLeft: "6px",
                    },
                  }}
                >
                  History
                </Btn>
              </Col>

              {auditTrailData && auditTrailData && auditTrailData?.length > 0 && (
                <TableContainer style={{ marginBottom: "15px" }} component={Paper}>
                  <Table sx={{ minWidth: 700 }} aria-label="simple table">
                    {auditTrailData && auditTrailData && auditTrailData?.length > 0 && (
                      <TableHead>
                        <TableRow>
                          <TableCell>Sr No</TableCell>
                          <TableCell>Process</TableCell>
                          <TableCell>Performed by</TableCell>
                          <TableCell>Date Started</TableCell>
                          <TableCell>Date Completed</TableCell>
                          <TableCell>Status</TableCell>
                        </TableRow>
                      </TableHead>
                    )}
                    {auditTrailData != null && auditTrailData && auditTrailData?.length > 0 ? (
                      <TableBody>
                        {auditTrailData.map((item, i) => (
                          <TableRow key={item.id}>
                            <TableCell>{i + 1}</TableCell>
                            <TableCell>{item?.StatusName || "N/A"}</TableCell>
                            <TableCell>{item?.peformedByName || "N/A"}</TableCell>
                            <TableCell>
                              {item.dateStarted
                                ? dayjs(item?.dateStarted).format("MM/DD/YYYY")
                                : "N/A"}
                            </TableCell>
                            <TableCell>
                              {item.dateCompleted
                                ? dayjs(item.dateCompleted).format("MM/DD/YYYY")
                                : "N/A"}
                            </TableCell>
                            <TableCell>{item.Status || "Completed"}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    ) : (
                      <TableBody>
                        <TableRow>
                          <TableCell colSpan={6} className="text-center p-2">
                            No Data Found
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    )}
                  </Table>
                </TableContainer>
              )}
            </CardBody>
          </Card> : null}
          {/* Approval Modal */}
          <ApprovalModal
            open={approvalHandleModal}
            onClose={handleClose}
            onSubmit={handleApprovalSubmit}
            plan={"Health"}
          />
          <DifferencesModal
            visible={openDiffModal}
            setVisible={setOpenDiffModal}
            data={differenceData.length > 0 ? differenceData : []}
            loadingPanel={loadingPanel}
            loading={differenceData && differenceData.length > 0 ? false : true}
          />
          <HistoryDataTable
            openHistory={isHistoryModalOpen}
            setOpenHistory={setIsHistoryModalOpen}
            data={historyData}
            sortData={sortData}
            selectedColumns={HistoryColumns}
            setSortedColumns={setSortedColumns}
            onSortChange={handleSortChange}
            actions={actions}
            title={"History"}
          />
        </Container>
      </ErrorBoundary>
    </Fragment>
  );
};

export default HealthOpenEnrollmentMain;
